import { LETTERS_ITEMS } from '@data/letters'

interface LettersPromptProps {
  word: string
  pattern: string
  level: number
}

export default function LettersPrompt({ word, pattern, level }: LettersPromptProps) {
  const icon = LETTERS_ITEMS.find(item => item.word === word)
  const Svg = icon?.Svg

  return (
    <div className="letters-prompt">
      {Svg ? (
        <div className="letters-prompt__icon">
          <Svg width={180} height={180} />
        </div>
      ) : null}
      <div className="letters-prompt__word" aria-label={`Fill the ${level === 1 ? 'first letter' : level === 2 ? 'vowel' : 'full word'} for ${pattern.replace(/_/g, 'blank')}`}>
        {pattern.split('').map((char, index) => (
          <span
            key={`${char}-${index}`}
            className={char === '_' ? 'letters-prompt__blank' : 'letters-prompt__letter'}
          >
            {char === '_' ? ' ' : char}
          </span>
        ))}
      </div>
    </div>
  )
}
